import { render, staticRenderFns } from "./tipo-deficiencia-container.vue?vue&type=template&id=00127c99&"
import script from "./tipo-deficiencia-container.vue?vue&type=script&lang=ts&"
export * from "./tipo-deficiencia-container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00127c99')) {
      api.createRecord('00127c99', component.options)
    } else {
      api.reload('00127c99', component.options)
    }
    module.hot.accept("./tipo-deficiencia-container.vue?vue&type=template&id=00127c99&", function () {
      api.rerender('00127c99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tipo-deficiencia/tipo-deficiencia-container.vue"
export default component.exports